<template>
    <div class="homepage">
       <head-menu current="0" />
       <head-swiper :imgArray="sliders" />
       <star-contributor />
       <news-list :news="news" />
       <sug-projects-list />
       <project-list :projects="projects" />
       <footer-links />
    </div>
</template>
<script>
import HeadMenu from '../../../common/head-menu';
import HeadSwiper from '../../../common/head-swiper';
import StarContributor from '../../../common/star-contributor';
import NewsList from '../../../common/news-list';
import SugProjectsList from '../../../common/sug-projects-list';
import ProjectList from '../../../common/project-list';
import FooterLinks from '../../../common/footer-links';
export default {
    components:{
        HeadMenu,
        HeadSwiper,
        StarContributor,
        NewsList,
        SugProjectsList,
        ProjectList,
        FooterLinks
    },
    data(){
        return{
            sliders:[
                {
                href:'https://github.com/brpc/brpc'
                },
                {
                 href:'https://github.com/apache/incubator-doris'
                },
                {
                 href:'https://echarts.baidu.com/index.html'
                }                
            ],
            news:[],
            projects:[]
        }
    },
    methods:{
        // 初始化新闻列表
        initNews(){
            this.$http.get('/api/news/list').then(response => {
            let status=response.status;
            let message=response.message;
            if(status === 200){
                // console.log(response.data);
                this.news = response.data.data.list.length > 3 ? response.data.data.list.slice(0,3) : response.data.data.list; 
            }
        
            }, response => {
                 alert("数据加载失败请重试");
            });
        },

        // 初始化项目列表
        initProjects(){
            this.$http.get('/api/project/list').then(response => {
            let status=response.status;
            let message=response.message;
            if(status === 200){
                this.projects = response.data.data.list.length > 10 ? response.data.datalist.slice(0,10) : response.data.data.list; 
            }
        
            }, response => {
                 alert("数据加载失败请重试");
            });
        }


        
    },
    created(){
        this.initProjects();
        this.initNews();
    }
    
    
}
</script>
<style lang="less" scoped>

</style>





// WEBPACK FOOTER //
// src/components/activity/homepage/index.vue